(function () {
  'use strict';
  var stub = window.dwDeferredReamaze;
  if (!stub) return;
  var launcher, loading = false, openRequested = false, finished = false, timer, script, observer;
  var sessionKey = 'dw-reamaze-active';

  function ready() {
    if (!window.Reamaze || window.Reamaze === stub) return;
    // Reamazeinit precedes the asynchronous React widget mount. Opening before
    // that mount loses the visitor's click because no popup listener exists yet.
    if (!document.getElementById('reamaze-widget-container')) return;
    finished = true;
    loading = false;
    clearTimeout(timer);
    if (observer) observer.disconnect();
    if (launcher) launcher.hidden = true;
    if (openRequested) {
      openRequested = false;
      window.Reamaze.popup();
    }
  }

  function failed() {
    loading = false;
    clearTimeout(timer);
    if (observer) observer.disconnect();
    if (launcher) {
      launcher.hidden = false;
      launcher.removeAttribute('aria-busy');
      launcher.setAttribute('aria-label', launcher.dataset.failedLabel);
      launcher.querySelector('[data-dw-chat-status]').textContent = launcher.dataset.failedLabel;
      launcher.dataset.fallback = 'true';
    }
    if (!window.Reamaze) window.Reamaze = stub;
    try { sessionStorage.removeItem(sessionKey); } catch (error) { /* Storage is optional. */ }
  }

  window.dwLoadReamaze = function (open) {
    openRequested = openRequested || !!open;
    if (finished) { ready(); return; }
    if (loading) return;
    loading = true;
    if (open) {
      try { sessionStorage.setItem(sessionKey, '1'); } catch (error) { /* Storage is optional. */ }
      if (launcher) {
        launcher.setAttribute('aria-busy', 'true');
        launcher.querySelector('[data-dw-chat-status]').textContent = launcher.dataset.loadingLabel;
      }
    }
    // Keep the sentinel until the SDK replaces it, preventing the app bootstrap
    // from starting a second download on a slow connection.
    script = document.createElement('script');
    script.src = 'https://cdn.reamaze.com/assets/reamaze.js';
    script.async = true;
    script.addEventListener('error', failed, { once: true });
    timer = setTimeout(failed, 30000);
    observer = new MutationObserver(ready);
    observer.observe(document.body, { childList: true, subtree: true });
    document.head.appendChild(script);
  };

  // Reamaze owns the account, customer, help centre, order and form settings.
  document.addEventListener('Reamazeinit', ready);
  window.addEventListener('Reamazeinit', ready);

  function init() {
    launcher = document.getElementById('dw-chat-launcher');
    if (launcher) {
      launcher.hidden = false;
      launcher.addEventListener('click', function (event) {
        if (launcher.dataset.fallback === 'true') return;
        event.preventDefault();
        window.dwLoadReamaze(true);
      });
    }
    var active = false;
    try { active = sessionStorage.getItem(sessionKey) === '1'; } catch (error) { /* Storage is optional. */ }
    if (active || document.querySelector('[data-reamaze-embed]')) window.dwLoadReamaze(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
